<template>
  <div>
    <v-container
      class="full-height"
      fluid
    >
      <export-payroll-employee-statutory
        v-if="$hasPermissionTo(['export employee statutory'])"
        class="mb-2"
      />

      <export-payroll-employee-contribution
        v-if="$hasPermissionTo(['export employee contributions'])"
        class="mb-2"
      />
    </v-container>
  </div>      
</template>
<script>
 
  export default {
    components: {
      ExportPayrollEmployeeContribution: () => import('@/components/hris/export/payroll/employee-contribution/EmployeeContribution'),
      ExportPayrollEmployeeStatutory: () => import('@/components/hris/export/payroll/employee-statutory/EmployeeStatutory'),
    },
  }
</script>
